export default __webpack_public_path__ + "static/inbox-provider-91c958f21dde924a017caa582340f048.png";